export function buildScenarioDisplayMetadata({
  scenarioRecord,
  metadataOverrides = {},
} = {}) {
  const record = scenarioRecord || {};
  return {
    id: metadataOverrides.id ?? record.id ?? null,
    title: metadataOverrides.title ?? record.title ?? null,
    levelOfCare: metadataOverrides.levelOfCare ?? record.levelOfCare ?? null,
    trainingLevel: metadataOverrides.trainingLevel ?? record.trainingLevel ?? record.levelOfCare ?? null,
    majorSystemInvolved:
      metadataOverrides.majorSystemInvolved ?? record.majorSystemInvolved ?? null,
    mechanismNatureOfInjury:
      metadataOverrides.mechanismNatureOfInjury ??
      record.mechanismNatureOfInjury ??
      record.majorSystemInvolved ??
      null,
    difficulty: metadataOverrides.difficulty ?? record.difficulty ?? null,
    ageRange: metadataOverrides.ageRange ?? record.ageRange ?? null,
    ageBracket: metadataOverrides.ageBracket ?? record.ageBracket ?? null,
    institution: metadataOverrides.institution ?? record.institution ?? null,
    isPublic: metadataOverrides.isPublic ?? record.isPublic ?? null,
    createdAt: metadataOverrides.createdAt ?? record.createdAt ?? null,
  };
}

export function buildScenarioDisplayProps({
  scenarioOutput,
  scenarioRecord,
  metadataOverrides = {},
  evaluationMode = false,
  evaluationData,
  onEvaluationChange,
  allowPrintControls = true,
  initialPrintMode,
} = {}) {
  return {
    scenario: scenarioOutput,
    metadata: buildScenarioDisplayMetadata({
      scenarioRecord,
      metadataOverrides,
    }),
    evaluationMode,
    evaluationData,
    onEvaluationChange,
    allowPrintControls,
    initialPrintMode,
  };
}
